import React, { useEffect } from 'react';
import { Space, Table, Tag, Card, Flex } from 'antd';

import { Button, Checkbox, Form, Input } from 'antd';
import ImagePicker from "components/pickers/image/MultiImagePicker"
import ProductService from 'services/product';
import { useParams, useNavigate } from "react-router"
import { useForm, useWatch } from "antd/es/form/Form";
import InputNumber from "components/input-number"
import MultiYoutubeVideoPicker from "components/pickers/youtube-video/MultiYoutubeVideoPicker"
import { useApp } from 'contexts/app';
import TagsPicker from "components/pickers/product_tag"
import CategoryPicker from "components/pickers/product_category"

const service = new ProductService();

const AddNewProductPage = () => {
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const { showNotify } = useApp();
  const onFinish = async (values) => {
    if (id) {
      var created = await service.updateGeneralInfo(values);
      //navigate(`/product/edit/${id}`);
      showNotify("Đã cập nhật")

    } else {
      var created = await service.create(values);
      navigate(`/product/edit/${created.id}`);
    }

    console.log('Success:', created);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    if (id) {
      loadData();
    }
  }, [id])

  const loadData = async () => {
    var item = await service.get(id);
    form.setFieldsValue(item)

  }
  return (
    <Form
      form={form}
      name="basic"
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 16,
      }}

      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <div>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Card size="small" title="Thông tin cơ bản" >

            <Form.Item
              hidden
              name="id"
            >

            </Form.Item>
            <Form.Item
              label="Tên"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập tên sản phẩm',
                },
              ]}
            >
              <Input></Input>
            </Form.Item>

            <Form.Item
              label="Hình ảnh"
              name="images"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng thêm hình ảnh',
                },
              ]}
            >
              <ImagePicker></ImagePicker>
            </Form.Item>

            <Form.Item
              label="Youtube Videos"
              name="videos"
              rules={[
                {
                  required: false,

                },
              ]}
            >
              <MultiYoutubeVideoPicker></MultiYoutubeVideoPicker>
            </Form.Item>





            <Form.Item
              label="Giá niêm yết"
              name="original_price"

            >
              <InputNumber ></InputNumber>
            </Form.Item>

            <Form.Item
              label="Giá bán"
              name="sales_price"

            >
              <InputNumber ></InputNumber>
            </Form.Item>


            <Form.Item
              label="Shopee Link"
              name="shopee_link"

            >
              <Input></Input>
            </Form.Item>


            <Form.Item
              label="Tiktok Link"
              name="tiktok_shop_link"

            >
              <Input></Input>
            </Form.Item>


            <Form.Item
              label="Tags"
              name="tags"

            >
              <TagsPicker mode="multiple"></TagsPicker>
            </Form.Item>

            <Form.Item
              label="Danh mục"
              name="category"

            >
              <CategoryPicker></CategoryPicker>
            </Form.Item>



            <Form.Item
              label="Số lượng đã bán"
              name="sales_count"

            >
              <InputNumber ></InputNumber>
            </Form.Item>


            {/* <Form.Item
              label="Video"
              name="videos"
              rules={[
                {
                  required: false,
                  message: 'Please input your password!',
                },
              ]}
            >
              <ImagePicker></ImagePicker>
            </Form.Item> */}



            <Form.Item
              label="Mô Tả"
              name="description"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập mô tả sản phẩm',
                },
              ]}
            >
              <Input.TextArea rows={8}></Input.TextArea>
            </Form.Item>



            <Flex justify='flex-end'>
              <Button type="primary" htmlType="submit">
                {id ? "Cập nhật" : "Tạo sản phẩm"}

              </Button>
            </Flex>


          </Card>



        </Space>
      </div>
    </Form>
  )
};
export default AddNewProductPage;